import { Component, Input, OnInit } from '@angular/core';
import ICombinedSolrStatistic = ZoningAPI.ICombinedSolrStatistic;
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-solr-group-ids-data-statistic',
    templateUrl: './solr-group-ids-data-statistic.component.html',
    styleUrls: ['./solr-group-ids-data-statistic.component.scss']
})
export class SolrGroupIdsDataStatisticComponent implements OnInit {
    @Input()
    data: ICombinedSolrStatistic;

    duplictedKeysStr: string;
    invalidCULsIdsCount: number;
    invalidCULsIdsStr: string;

    constructor() {}

    ngOnInit(): void {
        const keys = _.get(this.data, 'duplicatedKeys', []);
        this.duplictedKeysStr = _.isEmpty(keys) ? '-' : keys.join(', ');
        const invalidCULsIds = _.get(this.data, 'invalidCULsIds', []);
        this.invalidCULsIdsCount = invalidCULsIds.length;
        this.invalidCULsIdsStr = _.isEmpty(invalidCULsIds) ? '-' : this.data.invalidCULsIds.join(', ');
    }
}
